function FacebookIcon({ size = "24", color = "#b1272c" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24.502 24.502"
    >
      <path
        id="Icon_awesome-facebook-square"
        data-name="Icon awesome-facebook-square"
        d="M21.877,2.25H2.625A2.625,2.625,0,0,0,0,4.875V24.127a2.625,2.625,0,0,0,2.625,2.625h7.507v-8.33H6.686V14.5h3.446V11.513c0-3.4,2.024-5.277,5.123-5.277a20.874,20.874,0,0,1,3.037.265V9.837h-1.71a1.961,1.961,0,0,0-2.211,2.118V14.5h3.762l-.6,3.921h-3.16v8.33h7.507A2.625,2.625,0,0,0,24.5,24.127V4.875A2.625,2.625,0,0,0,21.877,2.25Z"
        transform="translate(0 -2.25)"
        fill={color}
      />
    </svg>
  );
}

export default FacebookIcon;
